import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  bottom: 0;
  width: 100%;
  max-height: 130px;
`;

export const LogoFooter = styled.img`
  width: 225px;
  height: auto;
  margin-top: 16px;
`;

export const TextFooter = styled.p`
  font-size: 14px;
  color: #4b5563;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.4px;
  margin-top: 16px;
`;
